import webAPIServices from "./webAPIServices";

export async function GetProductosNoVendidos(diasSinVenta) {
  const appsvc = new webAPIServices();
  const dias = diasSinVenta ?? 60;
  const requestUrl = `/backoffice/reportes/ProductosNoVendidos?diasSinVenta=${dias}`;
  return appsvc.Get(requestUrl);
}
